"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppStore = void 0;
const vue_1 = require("vue");
const injection_symbols_1 = require("./injection-symbols");
/* istanbul ignore next */
function useAppStore() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, vue_1.inject)(injection_symbols_1.appStoreKey)();
}
exports.useAppStore = useAppStore;
//# sourceMappingURL=use-api.js.map